import type { Ref } from 'vue';
import { computed } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';

import type { ITrackerGroupsFilterResponse } from '../types';
import {
  AFFILIATE_SHOW_TRACKER_GROUP_ITEM_API_URL,
  AFFILIATE_SHOW_TRACKER_GROUP_ITEM_QUERY,
  AFFILIATES_TRACKER_GROUPS_PERMISSIONS,
} from '../constants';

export default function useShowTrackerGroupItemQuery(id: Ref<number>, date: Ref<string | undefined>): IContextQueryResult<
  ITrackerGroupsFilterResponse
> {
  const { fetchGet } = useRestClient();

  return useContextQuery<ITrackerGroupsFilterResponse>({
    queryKey: [AFFILIATE_SHOW_TRACKER_GROUP_ITEM_QUERY, id, date],
    queryFn: ({ signal }) => fetchGet<ITrackerGroupsFilterResponse>(
      AFFILIATE_SHOW_TRACKER_GROUP_ITEM_API_URL,
      {
        signal,
        permission: AFFILIATES_TRACKER_GROUPS_PERMISSIONS.SHOW,
        queryParams: {
          'history_of_tracker_groups_change[affiliate_id]': id.value,
          'history_of_tracker_groups_change[date]': date.value,
        },
      },
    ),
    enabled: computed(() => !!id.value && !!date.value),
  });
}
